import React from "react";
import { StatusBadge, PriorityBadge, HealthBadge } from "@/components/Badges";
import { ProgressBar } from "@/components/ProgressBar";
import { countdown, formatWIB } from "@/lib/format";
import { cn } from "@/lib/utils";
import { AlertTriangle, GitBranch, Clock, MessageSquare, Layers, Building2 } from "lucide-react";

export default function TaskCard({ task, onClick }) {
  const cd = countdown(task.deadline_current, task.status);
  const showLateBanner = task.is_overdue && !task.late_report_id && task.status !== "selesai_terverifikasi";
  return (
    <div onClick={onClick} data-testid={`task-card-${task.id}`}
      className={cn("cursor-pointer rounded-2xl border bg-white p-4 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-lg space-y-3",
        task.is_overdue ? "border-rose-200" : "border-slate-200/80 hover:border-indigo-300")}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-semibold text-slate-800 leading-snug line-clamp-2">{task.title}</p>
          <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
            {task.branch && <span className="inline-flex items-center gap-1"><Building2 className="h-3 w-3" />{task.branch.name}</span>}
            {task.division && <span style={{ color: task.division.color }} className="font-semibold">• {task.division.name}</span>}
          </div>
        </div>
        <PriorityBadge priority={task.priority} />
      </div>

      {showLateBanner && (
        <div className="flex items-center gap-1.5 rounded-lg bg-rose-50 border border-rose-200 px-2.5 py-1.5 text-xs font-semibold text-rose-700">
          <AlertTriangle className="h-3.5 w-3.5" />Terlambat — isi Laporan Keterlambatan
        </div>
      )}

      <div>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-slate-500">Progres <span className="font-bold text-slate-700">{task.progress}%</span></span>
          <HealthBadge health={task.health} />
        </div>
        <ProgressBar value={task.progress} ideal={task.ideal_progress} />
      </div>

      <div className="flex items-center justify-between gap-2 flex-wrap">
        <StatusBadge status={task.status} />
        <span className={cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-mono font-bold", cd.cls)}>
          <Clock className="h-3 w-3" />{cd.text}
        </span>
      </div>

      <div className="flex items-center justify-between text-xs text-slate-400 pt-1 border-t border-slate-100">
        <span className="truncate">{task.assignee?.name || "Belum ada penerima"}</span>
        <div className="flex items-center gap-2.5 shrink-0">
          {task.is_cross_division && <span className="inline-flex items-center gap-0.5 text-fuchsia-600 font-semibold"><GitBranch className="h-3 w-3" />Lintas</span>}
          {task.subtask_count > 0 && <span className="inline-flex items-center gap-0.5"><Layers className="h-3 w-3" />{task.subtask_count}</span>}
        </div>
      </div>
    </div>
  );
}
